module.exports = __webpack_public_path__ + "img/Frame-90.0f1424c5.svg";